const divisions = [
  // {
  //   id: 1,
  //   title: "Web Development",
  //   subtitle: "Modern Websites",
  //   description:
  //     "Responsive websites built with React, Next.js and modern technologies.",
  //   color: "#ff2b2b",
  //   icon: "💻",
  // },
  {
    id: 2,
    title: "UI / UX Design",
    subtitle: "Creative Experiences",
    description:
      "Beautiful interfaces that increase engagement and conversions.",
    color: "#101010",
    icon: "🎨",
  },
  {
    id: 3,
    title: "Digital Marketing",
    subtitle: "Reach More Customers",
    description:
      "SEO, Google Ads, Meta Ads and complete marketing strategy.",
    color: "#101010",
    icon: "📈",
  },
  {
    id: 4,
    title: "Brand Identity",
    subtitle: "Build Your Brand",
    description:
      "Logo, branding systems and creative visual identities.",
    color: "#101010",
    icon: "🚀",
  },
  {
    id: 5,
    title: "Video Editing",
    subtitle: "Advanced Level Of Editing",
    description:
      "Crafting compelling visual stories with seamless editing, cinematic effects, and engaging content that captures attention and leaves a lasting impression.",
    color: "#101010",
    icon: "📱",
  },
  {
    id: 6,
    title: "Video Shoots",
    subtitle: "Shoot Your Brand",
    description:
      "Producing high-quality, professional video shoots that bring your brand, products, and stories to life with creativity and precision.",
    color: "#101010",
    icon: "🎥",
  },
  {
    id: 7,
    title: "AI Editing",
    subtitle: "Smart Business",
    description:
      "Leveraging advanced AI-powered editing tools to create stunning visuals, enhance content, and streamline creative workflows with speed and precision.",
    color: "#101010",
    icon: "🤖",
  },
  {
    id: 8,
    title: "Performance Marketing",
    subtitle: "Grow Faster",
    description:
      "Maximizing ROI through data-driven advertising, strategic campaign optimization, and performance-focused marketing that delivers measurable business growth.",
    color: "#101010",
    icon: "⚡",
  },
];

export default divisions;